<div class="modal-dialog start-test-dialog-container">
	<div class="modal-content" cdkTrapFocus>
		<div class="goreact-modal-header">
			<h4 class="modal-title" translate="modal-recording-instructions_this-is-a-test"></h4>
			<button type="button" class="close-btn" (click)="cancel()" [attr.aria-label]="'common_close' | translate">
				<i class="ficon-app-x"></i>
			</button>
		</div>
		<div class="goreact-modal-body">
			<p>
				<strong translate="modal-recording-instructions_one-attempt"></strong>
			</p>
			<p class="message-content" *ngIf="data.currentActivity.isCommentOnlySingleAttempt()" translate="modal-session-editor_single-attempt-comment-only"></p>
			<p class="message-content" *ngIf="!data.currentActivity.isCommentOnlySingleAttempt()" translate="modal-recording-instructions_upload-not-available"></p>
			<p
				class="time-limit"
				*ngIf="data.currentActivity.time_limit > 0"
				translate="modal-recording-instructions_time-limit"
				[translateParams]="{ number: data.currentActivity.time_limit }">
			</p>
			<p
				class="time-limit"
				*ngIf="!data.currentActivity.time_limit"
				translate="modal-recording-instructions_no-time-limit">
			</p>
			<p
				class="screen-capture-warning"
				*ngIf="showScreenCaptureWarning()"
				translate="modal-recording-instructions_no-screen-capture">
			</p>
		</div>
		<div class="goreact-modal-footer">
			<button
				type="button"
				class="cancel-btn tertiary-btn"
				(click)="cancel()"
				translate="common_not-yet">
			</button>
			<button
				class="confirm-button primary-btn"
				(click)="confirm()"
				data-cy="start-test-button"
				translate="modal-recording-instructions_start-test">
			</button>
		</div>
	</div>
</div>
